import { actions, useDispatch } from '@sloyd/store-base';
import classnames from 'classnames';
import { useState } from 'react';
import { useMount } from 'react-use';
import { invokeEvent } from 'shared-base';
import { useCustomEvent } from '../hooks/useCustomEvent';
import { useFrameOuter } from './Viewer.hooks';
import { IFrame } from './Viewer.style';
import { Stage } from './Viewer.types';
import { log } from './Viewer.utils';

export type ViewerContainerProps = {
  children?: React.ReactNode;
  unityVersion: UnityVersion;
  onReady?: () => void;
  instanceId: string;
};

export function ViewerContainer(props: ViewerContainerProps) {
  const dispatch = useDispatch();
  const { instanceId = 'default', unityVersion = 'stable' } = props;
  const [isActive, setIsActive] = useState(true);

  useMount(() => {
    dispatch(actions.appState.patch({ isUnityReady: false }));
    log(Stage.CONTAINER_MOUNT);
  });

  useCustomEvent('UnityActive', (ev) => {
    setIsActive(ev.isActive);
  });

  function onReceive(ev: any) {
    const { type, verb, instanceId, data = {} } = ev;

    if (type === 'LIFECYCLE' && verb === 'loaded') {
      log(Stage.CONTAINER_ON_READY);
      props.onReady?.();
      return;
    } else if (type === 'UNITY') {
      invokeEvent(ev.type, { ...data, instanceId });
    } else if (type === 'ACTION') {
      dispatch(data);
    }
  }

  const [sendMessage, ref] = useFrameOuter(instanceId, onReceive);

  useCustomEvent(
    'UnityBridge1',
    (ev) => {
      log(Stage.CONTAINER_INSTRUCTIONS, ev);
      const { message, data } = ev;
      sendMessage({ type: 'UnityBridge2', message, data });
    },
    []
  );

  const src = `/viewer/raw/${instanceId}?unityVersion=${unityVersion}&transparent=true`;

  const className = classnames({
    inactive: !isActive,
  });

  return <IFrame className={className} src={src} ref={ref}></IFrame>;
}

export default ViewerContainer;
